(() => {
const init = () => {
 const root = document.querySelector('[data-product-id="11759940239701"]');
 const story = document.querySelector('.hd-window-story');
 const data = document.querySelector('[data-hd-window-photos]');
 if (!root || !story || !data || root.dataset.hdWindowReady) return;
 root.dataset.hdWindowReady = 'true';
 const photos = JSON.parse(data.textContent).images;
 const update = () => {
  const colour = root.querySelector('.hd-pdp-colour-options input:checked')?.value || 'Rot';
  const slug = colour.toLowerCase().replace('ü','ue');
  const prefix = 'vogelhaus-fensterlaeden-' + slug + '-';
  story.querySelectorAll('[data-hd-window-photo]').forEach(holder => {
   const photo = photos.find(item => item.filename.includes(prefix) && item.filename.includes(holder.dataset.hdWindowPhoto));
   const image = holder.querySelector('img');
   if (!photo || !image || image.dataset.colour === colour) return;
   image.removeAttribute('srcset'); image.src = photo.src; image.alt = photo.alt || ''; image.dataset.colour = colour;
  });
 };
 root.addEventListener('change', () => requestAnimationFrame(update));
 update();
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
document.addEventListener('shopify:section:load',init);
})();